import { Injectable } from '@angular/core';

import { ScrollFreezeServiceTypes } from '@frontend/sports/common/core/feature/scroll-freeze';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { ModalDialogOptions, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';

import { PrintLoadingIndicatorComponent } from './print-loading-indicator.component';

@Injectable({ providedIn: 'root' })
export class PrintLoadingIndicatorDialogService {
    private dialogOptions: ModalDialogOptions<void>;
    private modalRef: Nullable<ModalRef>;

    constructor(private modalDialogService: ModalDialogService) {
        this.dialogOptions = {
            settings: {
                scrollFreezeType: ScrollFreezeServiceTypes.Page,
                hideCloseButton: true,
                cssClass: 'print-loading-indicator',
            },
        };
    }

    show(): void {
        this.close();
        this.modalRef = this.modalDialogService.openDialog(PrintLoadingIndicatorComponent, this.dialogOptions);

        if (this.modalRef) {
            this.modalRef.result.catch(() => this.close());
        }
    }

    close(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
        }
    }
}
